const resource = 'users';

export default ($axios, isAdmin = false) => ({
    // GET
    getAdmins(params = {}) {
        return $axios.get(`/superAdmin/${resource}`, { params });
    },
    getUsers(params = {}) {
        return $axios.get(`/${resource}`, { params });
    },
    getManagers(params = {}) {
        return $axios.get(
            isAdmin ? '/superAdmin/userManagers' : `/${resource}/managers`,
            { params }
        );
    },
    getUserMenu(params = {}) {
        return $axios.get(`/menu`, { params });
    },
    getUserProfile(params = {}) {
        return $axios.get(`/profile`, { params });
    },
	getUserConfig(params = {}) {
		return $axios.get(`/profile/config`, { params });
	},
    // PUT
    updateUserProfile(userId, user) {
        return $axios.put(`/profile/${userId}`, user);
    },
});
